const UNITS = [" bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

// Any more complex behaviour should consider a 3rd party libary such as pretty-bytes
export const formatBytes = (bytes: number): string => {
  if (typeof bytes !== "number" || Number.isNaN(bytes) || Math.round(Math.abs(bytes)) < 1) {
    return "0 bytes";
  }

  const k = 1000;
  const i = Math.floor(Math.log(Math.abs(bytes)) / Math.log(k));
  const number = bytes / k ** i;
  const decimal = +(number < 10 && i > 0);

  if (!UNITS[i]) return "? bytes";

  return `${number.toFixed(decimal)}${UNITS[i] ?? UNITS[UNITS.length - 1]}`;
};
